import { Counter, Leaders, Team, Title } from '@components/About/index';

function AboutUs() {
  return (
    <>
    <Title />
    <Leaders />
    <Team />
    <Counter />
    </>
  );
}

export default AboutUs;
